import React from 'react';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InsightsIcon from '@mui/icons-material/Insights';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PeopleIcon from '@mui/icons-material/People';
import HomeCard from '../shared/HomeCard';
import { useAuth } from '../context/AuthContext';
import { categories } from '../config/categories';
import { getCategoryRuleCounts } from '../config/rules';

export default function MainDashboard() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';

  return (
    <div className="page">
      <Link to="/" className="back-link">
        <ArrowBackIcon fontSize="small" /> Back to Home
      </Link>
      <div className="home-hero">
        <h1>Welcome{user?.name ? `, ${user.name}` : ''}</h1>
        <p>Explore survey data, analytics, and validation-rule categories.</p>
      </div>

      {/* Section A — core tools */}
      <section className="home-section">
        <h2 className="home-section-title">Explore</h2>
        <div className="card-grid">
          <HomeCard
            to="/dashboard"
            title="Dashboard"
            description="Survey KPIs, time/household/children stats and the records table."
            icon={DashboardIcon}
            accent="var(--primary)"
          />
          <HomeCard
            to="/analytics"
            title="Analytics"
            description="Group-by analytics across enumerator, block, GP and village."
            icon={InsightsIcon}
            accent="var(--cat-gender)"
          />
          {isAdmin && (
            <HomeCard
              to="/upload"
              title="Upload Data"
              description="Append a 2-sheet Excel export (household + member details)."
              icon={CloudUploadIcon}
              accent="var(--cat-skill-livelihood)"
            />
          )}
        </div>
      </section>

      {/* Section B — validation-rule categories */}
      <section className="home-section">
        <h2 className="home-section-title">Validation Rules</h2>
        <div className="card-grid">
          {categories.map((cat) => {
            const { total, available } = getCategoryRuleCounts(cat.id);
            return (
              <HomeCard
                key={cat.id}
                to={`/category/${cat.id}`}
                title={cat.label}
                description={cat.description}
                icon={cat.icon}
                accent={cat.accent}
                badge={`${available} of ${total} available`}
              />
            );
          })}
        </div>
      </section>

      {/* Section C — admin */}
      {isAdmin && (
        <section className="home-section">
          <h2 className="home-section-title">Administration</h2>
          <div className="card-grid">
            <HomeCard
              to="/users"
              title="Users"
              description="Manage dashboard users — add or remove admins and executives."
              icon={PeopleIcon}
              accent="var(--cat-subhadra)"
            />
          </div>
        </section>
      )}
    </div>
  );
}
